// In MpiFormBuilderDasboard.js
import React, { useState } from 'react';
import WorkItemPresetTable from './WorkItemPresetTable';
import CsvWorkItemPresetImporterModal from './CsvWorkItemPresetImporterModal';
import { Button } from '@mui/material';

const MpiFormBuilderDasboard = () => {
  const [importOpen, setImportOpen] = useState(false);

  return (
    <div className="container-fluid p-3">
      <div className="card mb-4">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5>Work Item Presets</h5>
          <Button variant="contained" color="primary" onClick={() => setImportOpen(true)}>
            Import CSV
          </Button>
        </div>
        <div className="card-body">
          <WorkItemPresetTable />
        </div>
      </div>

      <CsvWorkItemPresetImporterModal 
        open={importOpen} 
        onClose={() => setImportOpen(false)} 
      />
    </div>
  );
};

export default MpiFormBuilderDasboard;